import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

/** Copies `value` to clipboard, shows a short confirmation. */
export default function CopyIdButton({ value, testid = "copy-req-id", label = "نسخ" }) {
  const [copied, setCopied] = useState(false);
  const onClick = async () => {
    if (!value) return;
    try {
      await navigator.clipboard.writeText(String(value));
      setCopied(true);
      toast.success("تم نسخ Request ID");
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("تعذّر النسخ");
    }
  };
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={onClick}
      title={value || ""}
      className="inline-flex items-center gap-1 text-xs font-bold bg-slate-100 hover:bg-slate-200 text-slate-700 px-2 py-1 rounded-md cursor-pointer"
    >
      {copied ? <Check className="w-3 h-3" /> : <Copy className="w-3 h-3" />}
      <span>{copied ? "منسوخ" : label}</span>
    </button>
  );
}
